import { useEffect, useRef } from 'react';
import useScreenSize from '../useScreenSize';
import {
  AdriverCustom,
  TargetedBannerIds,
  TargetedBannerKeys
} from '../../types';

const lotriverBGLeftClass = '.lotriver-bg-left';
const lotriverBGRightClass = '.lotriver-bg-right';

const formatCustomData = (custom: object): string => {
  return Object.entries(custom)
    .map(([key, value]) => `${key}=${value}`)
    .join(';');
};

export const useTargetedBanner = (
  bannerId: TargetedBannerIds,
  custom: AdriverCustom,
  shouldNotRunOnRouter: boolean
) => {
  const isFirstRun = useRef(true);
  const { isLarge } = useScreenSize();

  const bannerData = {
    [TargetedBannerIds.bg]: { sid: 220686, bt: 52, bn: 4, custom },
    [TargetedBannerIds.catfish]: {
      sid: 220686,
      bn: 5,
      bt: 52,
      w: 700,
      h: 120,
      custom
    }
  };

  const removeOldBanners = (selector: string) =>
    document.querySelectorAll(selector).forEach(el => el.remove());

  useEffect(() => {
    if (!Object.keys(custom || {}).length) return;
    if (!isFirstRun.current && shouldNotRunOnRouter) return;

    const init = () => {
      const bannerKey = TargetedBannerKeys[bannerId];

      try {
        if (
          window[bannerKey]?.loadCompleteQueue?.flag &&
          typeof window[bannerKey].reload === 'function'
        ) {
          if (bannerId === TargetedBannerIds.bg) {
            removeOldBanners(lotriverBGLeftClass);
            removeOldBanners(lotriverBGRightClass);
          }

          if (window[bannerKey]?.prm) window[bannerKey].prm.custom = custom;
          if (window[bannerKey]?.reqPrm)
            window[bannerKey].reqPrm.custom = formatCustomData(custom);

          window[bannerKey].reload();
        } else if (!window[bannerKey] && typeof window.adriver === 'function') {
          // eslint-disable-next-line new-cap
          window[bannerKey] = new window.adriver(
            bannerId,
            bannerData[bannerId]
          );
        }
      } catch (e) {
        console.error(e);
      }
      isFirstRun.current = false;
    };

    const t = window.setTimeout(init, 2000);
    return () => window.clearTimeout(t);
  }, [custom, bannerId, shouldNotRunOnRouter]);

  useEffect(() => {
    const leftBanner = document.querySelector(
      lotriverBGLeftClass
    ) as HTMLElement | null;
    const rightBanner = document.querySelector(
      lotriverBGRightClass
    ) as HTMLElement | null;

    if (leftBanner && rightBanner) {
      leftBanner.style.display = isLarge ? 'block' : 'none';
      rightBanner.style.display = isLarge ? 'block' : 'none';
    }
  }, [isLarge]);
  return null;
};
